import React from 'react';
import { string } from 'prop-types';
import styles from './styles/styles.module.scss';

const CommunityStat = ({ title, subtitle, text, className }) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={styles.title}>{title}</div>
      <div className={styles.subtitle}>{subtitle}</div>
      <div className={styles.text}>{text}</div>
    </div>
  );
};

CommunityStat.propTypes = {
  title: string,
  subtitle: string,
  text: string,
  className: string
};

CommunityStat.defaultProps = {
  title: '',
  subtitle: '',
  text: '',
  className: ''
};

export default CommunityStat;
